<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { RouterLink } from 'vue-router';
import { defaultConsent, loadConsent, saveConsent } from '../utils/consent';

const visible = ref(false);

onMounted(() => {
  visible.value = loadConsent() === null;
});

function acceptAll() {
  saveConsent({ essential: true, analytics: true, marketing: true, decidedAt: new Date().toISOString() });
  visible.value = false;
}

function rejectNonEssential() {
  saveConsent({ ...defaultConsent(), decidedAt: new Date().toISOString() });
  visible.value = false;
}
</script>

<template>
  <div
    v-if="visible"
    class="fixed inset-x-0 bottom-0 z-40 border-t border-black/10 bg-[#fdf8f8] px-4 py-4 text-[#1c1b1b] shadow-[0_-4px_20px_rgba(0,0,0,0.08)]"
  >
    <div class="max-w-5xl mx-auto flex flex-col sm:flex-row sm:items-center gap-4 text-[14px] leading-[1.5]">
      <p class="flex-1">
        We use essential cookies to make the site work. With your consent, we'd also use analytics to improve it.
        <RouterLink to="/legal/cookies" class="text-black underline hover:opacity-70">Customize</RouterLink>
      </p>
      <div class="flex gap-2 shrink-0">
        <button
          type="button"
          class="rounded-full border border-black text-black px-4 py-2 font-medium text-[14px] hover:bg-black hover:text-white transition-colors"
          @click="rejectNonEssential"
        >Essential only</button>
        <button
          type="button"
          class="rounded-full bg-black text-white px-4 py-2 font-medium text-[14px] hover:opacity-90 transition-opacity"
          @click="acceptAll"
        >Accept all</button>
      </div>
    </div>
  </div>
</template>
